import { apiClient } from "lib/apiClient";
import { IReviewsResponse } from "features/Reviews/types";

export const getAssetDashboardReviews = async (
  propertyId: string
): Promise<IReviewsResponse> => {
  const response = await apiClient.get(
    `/property/${propertyId}/asset-dashboard/reviews`
  );

  return response.data;
};
